import { render } from "./InformationPanel.vue?vue&type=template&id=11a45df7&ts=true"
import script from "./InformationPanel.vue?vue&type=script&lang=ts"
export * from "./InformationPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__